export const supportsAgentRollback = (
    agentCreatedAt?: Date | string
  ): boolean => {
    const rollbackEnabledFrom =
      process.env.REACT_APP_BACK4APP2_AGENT_ROLLBACK_ENABLED_FROM ||
      '2026-03-23T00:00:00.000Z';
  
    if (!rollbackEnabledFrom) {
      return false;
    }
  
    if (!agentCreatedAt) {
      return false;
    }
  
    const cutoffDate = new Date(rollbackEnabledFrom);
    const createdAtDate = new Date(agentCreatedAt);
  
    if (
      Number.isNaN(cutoffDate.getTime()) ||
      Number.isNaN(createdAtDate.getTime())
    ) {
      return false;
    }
  
    return createdAtDate >= cutoffDate;
};